<template lang="pug">
.ref-email-form
	//button.ref-email-form__back(@click="goBack()")
		i.fas.fa-arrow-left
		p Back
	//.ref-email-form__divider
	p.ref-email-form__header Please enter your information below so we can thank you for your referral.
	.ref-email-form__input-row
		label.ref-email-form__input-title(for="name") Your Name
		input(type="text", id="name", placeholder="Enter your full name", v-model="data.name")
	.ref-email-form__input-row
		label.ref-email-form__input-title(for="email") Your Email Address
		input(type="text", id="email", placeholder="Enter your full name", v-model="data.email")
	.ref-email-form__input-row
		label.ref-email-form__input-title(for="phone") Your Phone Number *
		input(type="text", id="phone", placeholder="Enter your phone number", v-model="data.phone" :class="{'invalid' : phoneInvalid}", @focus="phoneInvalid = false" @blur="validateInput('phone')")
		p.ref-email-form__error(v-if="phoneInvalid") Your phone number is required
	.ref-email-form__input-row
		label.ref-email-form__input-title(for="member") The Last Four Digits of Your Membership Number *
			.ref-email-form__input-info(tabindex="0") ?
				p.ref-email-form__input-info-text We need this to pay your bonus.
		a.ref-email-form__input-link(href="https://www.uhcu.org/resources/member-number",) How do I find this?
		input(type="text", id="member", placeholder="Enter the last four (4) digits of your membership number", v-model="data.member" :class="{'invalid' : memberInvalid}", @focus="memberInvalid = false" @blur="validateInput('member')")
		p.ref-email-form__error(v-if="memberInvalid") The last four (4) digits of your membership number is required
	.ref-email-form__divider
	p.ref-email-form__header Personalize the email to your friend.
	.ref-email-form__input-row
		label.ref-email-form__input-title(for="refName") Name *
		input(type="text", id="refName", placeholder="Enter your friend's full name", v-model="data.refName", :class="{'invalid' : refNameInvalid}", @focus="refNameInvalid = false" @blur="validateInput('refName')")
		p.ref-email-form__error(v-if="refNameInvalid") Friend's email address is required
	.ref-email-form__input-row
		label.ref-email-form__input-title(for="refEmail") Email Address *
		input(type="text", id="refEmail", placeholder="Enter your friend's email address", v-model="data.refEmail", :class="{'invalid' : refEmailInvalid}", @focus="refEmailInvalid = false" @blur="validateInput('refEmail')")
		p.ref-email-form__error(v-if="refEmailInvalid") Friend's email address is required
	.ref-email-form__input-row
		label.ref-email-form__input-title(for="refSubject") Subject Line *
		input(type="text", id="refSubject", v-model="data.refSubject", :class="{'invalid' : refSubjectInvalid}", @focus="refSubjectInvalid = false" @blur="validateInput('refSubject')")
		p.ref-email-form__error(v-if="refSubjectInvalid") Email subject is required
	.ref-email-form__input-row
		label.ref-email-form__input-title(for="refNote") Note *
		textarea( id="refNote", v-model="data.refNote", rows="2", :class="{'invalid' : refNoteInvalid}", @focus="refNoteInvalid = false", @blur="validateInput('refNote')")
		p.ref-email-form__error(v-if="refNoteInvalid") Email Note is required
	button.ref-email-form__submit(@click="submit()", type="button", :disabled="config.sendDisable") Send
	input#emailSubject(type="hidden", value="Referral Form Subject")
</template>

<script>
export default {
  name: "EmailForm",
  components: {},
  props: ["data", "config"],
  data() {
    return {
      phoneInvalid: false,
      memberInvalid: false,
      refNameInvalid: false,
      refEmailInvalid: false,
      refSubjectInvalid: false,
      refNoteInvalid: false,
    };
  },
  methods: {
    validateInput(type) {
      if (
        this.data[type] === "" ||
        (type === "refEmail" && !this.validateEmail(this.data[type])) ||
        (type === "phone" && !this.validatePhone(this.data[type])) ||
        (type === "member" && !this.validateMember(this.data[type]))
      ) {
        this[`${type}Invalid`] = true;
      }
    },
    goBack() {
      Object.keys(this.data).forEach((key) => {
        this.data[key] = "";
      });

      this.data.subject = document.querySelector("#emailSubject").value;

      //alert("Subject: " + this.data.subject);

      this.data.note = document.querySelector("#emailNote").value;
      this.$emit("goToPage", "welcome");
    },
    submit() {
      let valid = true;
      Object.keys(this.data).forEach((key) => {
        if (
          (this.data[key] === "" && key !== "email" && key !== "name") ||
          (key === "refEmail" && !this.validateEmail(this.data[key])) ||
          (key === "phone" && !this.validatePhone(this.data[key])) ||
          (key === "member" && !this.validateMember(this.data[key]))
        ) {
          this[`${key}Invalid`] = true;
          valid = false;
        }
      });

      if (!valid) return;
      this.config.sendDisable = true;
      this.$emit("submit");
    },
    validateEmail(email) {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    validatePhone(phone) {
      const re = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/;
      return re.test(String(phone).toLowerCase());
    },
    validateMember(member) {
      const re = /^[0-9]{4}$/;
      return re.test(String(member).toLowerCase());
    },
  },
};
</script>

<style lang="scss">
.ref-email-form {
  &__back {
    cursor: pointer;
    background: transparent;
    border: 0;
    font-size: 0.9rem;
    color: #005580;
    p {
      margin: 0;
      padding-left: 0.5rem;
      display: inline-block;
    }
  }

  &__divider {
    border-top: 1px solid #979797;
    margin-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  &__header {
    font-size: 1.1rem;
    color: #2b2e2f;
    margin-bottom: 0.5rem;
    font-weight: bold;
  }
  &__input-title {
    margin-bottom: 0.25rem;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  &__input-header {
    margin-bottom: 0.5rem;
  }
  &__input-row {
    position: relative;
    display: flex;
    flex-direction: column;
    padding-bottom: 1.25rem;
  }
  &__input-info {
    position: relative;
    margin: 0rem;
    padding: 0 0.25rem;
    margin-left: 1rem;
    background-color: rgb(225, 225, 225);
    border-radius: 100vw;
    cursor: pointer;
    &-text {
      margin: 0rem;
      padding: 0;
      position: absolute;
      display: none;
      z-index: 10;
      background-color: white;
      color: black;
      padding: 1rem;
      border: 2px solid black;
      border-radius: 0.25rem;
      min-width: 256px;
      left: 50%;
      transform: translateX(-50%);

      @media (width < 768px) {
        right: 0;
        left: unset;
        transform: unset;
      }
    }
    &:hover,
    &:focus-visible,
    &:focus {
      .ref-email-form__input-info-text {
        display: flex;
      }
    }
  }
  input,
  textarea {
    min-height: 47px;
    box-sizing: border-box;
    border: 1px solid #bdcbd1;
    border-radius: 8px;
    padding: 0.5rem 0.3875rem;
    transition: 0.25s ease;
    color: #757575;
    &.invalid {
      background: #fdeded;
      border-color: #f59ea3;
    }
  }
  &__error {
    position: absolute;
    bottom: 0;
    color: #b5121b;
    font-size: 0.75rem;
    //padding-top: .25rem;
    margin: 0;
  }
  &__submit {
    height: 48px;
    width: 150px;
    z-index: 1;
    border-radius: 8px;
    border: 0;
    margin-top: 1.5rem;
    color: #ffffff;
    background: #b5121b;
    cursor: pointer;
    transition: 0.45s ease;
    position: relative;
    display: flex;
    overflow: hidden;
    align-items: center;
    justify-content: center;
    &:hover {
      text-decoration: none;
      color: #fff;
      &:after {
        transform: skewX(-20deg) scale(1, 1);
      }
    }
    &:after {
      position: absolute;
      z-index: -1;
      top: 0;
      right: 0;
      bottom: 0;
      left: -10px;
      width: calc(100% + 20px);
      content: "";
      transition: 0.45s ease;
      transform: skewX(-20deg) scale(0, 1);
      transform-origin: left;
      background: #3d505a;
    }
    &:focus {
      outline: none;
    }
    &:focus-visible {
      outline: 5px auto -webkit-focus-ring-color;
      text-decoration: none;
      color: #fff;
      &:after {
        transform: skewX(-20deg) scale(1, 1);
      }
    }
  }
  &__submit:disabled {
    background: #636667;
  }
}
</style>
